<template>
  <div class="top-bar">
    <div class="logo-section">
      <img src="@/assets/logo.png" alt="Logo" class="logo" />
    </div>
    
    <div class="title-section">
      <h1 class="title">弥特采集关联系统 SCADA 监控大屏</h1>
    </div>
    
    <div class="info-section">
      <div class="user-name">{{ userName || '未知用户' }}</div>
      <div class="current-time">{{ currentTime }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  props: {
    userName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentTime: '',
      timeTimer: null
    }
  },
  mounted() {
    this.updateTime()
    this.timeTimer = setInterval(this.updateTime, 1000)
  },
  beforeDestroy() {
    if (this.timeTimer) {
      clearInterval(this.timeTimer)
    }
  },
  methods: {
    updateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const date = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      
      // 完整的日期时间格式，精确到秒
      this.currentTime = `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style lang="scss" scoped>
.top-bar {
  height: 80px;
  background: linear-gradient(180deg, rgba(0, 255, 255, 0.1) 0%, rgba(0, 255, 255, 0.05) 100%);
  border: 1px solid rgba(0, 255, 255, 0.3);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-shadow: 0 0 20px rgba(0, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
  
  // 发光效果
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(0, 255, 255, 0.1), transparent);
    animation: shine 3s infinite;
  }
}

@keyframes shine {
  to {
    left: 100%;
  }
}

.logo-section {
  flex: 0 0 auto;
  
  .logo {
    height: 50px;
    filter: drop-shadow(0 0 10px rgba(0, 255, 255, 0.5));
  }
}

.title-section {
  flex: 1;
  text-align: center;
  
  .title {
    font-size: 36px;
    font-weight: bold;
    color: #00ffff;
    text-shadow: 
      0 0 10px rgba(0, 255, 255, 0.8),
      0 0 20px rgba(0, 255, 255, 0.6),
      0 0 30px rgba(0, 255, 255, 0.4);
    letter-spacing: 4px;
    margin: 0;
    font-family: 'Microsoft YaHei', sans-serif;
  }
}

.info-section {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  
  .current-time {
    font-size: 18px;
    color: #00ffff;
    text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
    font-family: 'Courier New', monospace;
  }
  
  .user-name {
    font-size: 16px;
    color: #ffffff;
    text-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
    
    &::before {
      content: '👤 ';
    }
  }
}
</style>
